import _styled from "styled-components";
import React from "react";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { ModalScreen } from "../ModalScreen/ModalScreen";

var StyledModalScreen = _styled(ModalScreen).withConfig({
  displayName: "EnumInputModal__StyledModalScreen",
  componentId: "tdtbk5-0"
})(["background-color:white;"]);

var Container = _styled.div.withConfig({
  displayName: "EnumInputModal__Container",
  componentId: "tdtbk5-1"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var Description = _styled.div.withConfig({
  displayName: "EnumInputModal__Description",
  componentId: "tdtbk5-2"
})(["flex:0 0 auto;text-align:center;margin-top:60px;font-size:24px;"]);

var ParamsContainer = _styled.div.withConfig({
  displayName: "EnumInputModal__ParamsContainer",
  componentId: "tdtbk5-3"
})(["flex:1 1 0;margin-top:40px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

var Item = _styled.button.withConfig({
  displayName: "EnumInputModal__Item",
  componentId: "tdtbk5-4"
})(["display:flex;background:transparent none;border:0 none;text-align:center;padding:0;width:100%;justify-content:center;"]);

var ItemText = _styled.div.withConfig({
  displayName: "EnumInputModal__ItemText",
  componentId: "tdtbk5-5"
})(["position:relative;font-size:18px;padding:12px 16px;"]);

var CheckedMark = _styled.div.withConfig({
  displayName: "EnumInputModal__CheckedMark",
  componentId: "tdtbk5-6"
})(["position:absolute;top:50%;right:100%;transform:translateY(-50%);svg{display:block;fill:#4d9ade;}"]);

export function EnumInputModal(_ref) {
  var isOpen = _ref.isOpen,
      currentValue = _ref.currentValue,
      valuesEnum = _ref.valuesEnum,
      title = _ref.title,
      onClose = _ref.onClose,
      onDone = _ref.onDone;
  return /*#__PURE__*/React.createElement(StyledModalScreen, {
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Description, null, title), /*#__PURE__*/React.createElement(ParamsContainer, null, valuesEnum.map(function (title, value) {
    return title.length > 0 ? /*#__PURE__*/React.createElement(Item, {
      key: value,
      onClick: function onClick() {
        return onDone(value);
      }
    }, /*#__PURE__*/React.createElement(ItemText, null, title, "".concat(currentValue) === "".concat(value) && /*#__PURE__*/React.createElement(CheckedMark, null, /*#__PURE__*/React.createElement(SuccessIcon, {
      width: "24",
      height: "24"
    })))) : null;
  }))));
}